<template>
    <v-popover offset="0" :autoHide="true">
        <button class="tooltip-target btn btn-sm btn-outline-success mr-2" data-testid="client-medical-report-save"><i class="fa fa-save" aria-hidden="true"></i> Uložit</button>
        <template slot="popover">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h3>opravdu?</h3>
                <b class="text-danger">uložením přepíšete původní lékařskou zprávu</b>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <button class="tooltip-target btn btn-success" data-testid="client-medical-report-save-confirm" @click="confirm" v-close-popover><i class="fa fa-save" aria-hidden="true"></i> Uložit</button>
            </div>
        </div>
    </div>
    </template>
    </v-popover>
</template>

<script>
  export default {
    data () {
      return {
        changePending: false,
        changeError: null,
        visit: {},
        isOpen: false
      }
    },
    methods: {
      confirm () {
        this.$emit('confirmed')
      }
    },
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Client/popovers/MedicalReportConfirmSave.vue?79022797